import request from './request'


//登录
export function login(params) {
    return request(`/scheduling/sys/auth/login`, 'post', params || {})
}
//退出登录
export function logOut(params) {
    return request(``, 'get', params || {})
}

//修改密码
export function setPass(params) {
    return request(`/scheduling/user/updatePassword`, 'post', params || {})
}

//司机资源库列表
export function getDrivers(params) {
    return request(`/scheduling/driverVehicle/queryDriverVehicle`, 'get', params || {})
}
//司机信息导出
export function exportDriverVehicles(params) {
    return request(`/scheduling/driverVehicle/exportDriverVehicles`, 'get', params || {}, {
        responseType: 'blob'
    })
}
//新增司机
export function addDrivers(params) {
    return request(`/scheduling/driverVehicle/addDriverVehicle`, 'post', params || {})
}
//司机详情
export function getDriverVehicleDetail(params) {
    return request(`/scheduling/driverVehicle/getDriverVehicleDetail`, 'get', params || {})
}
//司机编辑
export function editDrivers(params) {
    return request(`/scheduling/driverVehicle/updateDriverVehicle`, 'post', params || {})
}
//司机删除
export function delDrivers(params) {
    return request(`/scheduling/driverVehicle/deleteDriverVehicle`, 'get', params || {})
}
//车辆概览
export function getCars(params) {
    return request(`/scheduling/driverVehicle/statisticsDriverVehicleSituation`, 'get', params || {})
}
//查询调度员
export function getDispatchers(params) {
    return request(`/scheduling/dispatcher/list`, 'get', params || {})
}

//调度员息导出
export function exportDispatcher(params) {
    return request(`/scheduling/dispatcher/export`, 'get', params || {}, {
        responseType: 'blob'
    })
}
//新增调度员
export function addDispatcher(params) {
    return request(`/scheduling/dispatcher/add`, 'post', params || {})
}
//编辑调度员
export function editDispatcher(params) {
    return request(`/scheduling/dispatcher/update`, 'post', params || {})
}
//删除调度员
export function delDispatcher(params) {
    return request(`/scheduling/dispatcher/delete`, 'post', params || {})
}

//任务列表
export function queryTask(params) {
    return request(`/scheduling/task/queryTask`, 'post', params || {})
}
//查询巷道
export function queryLane(params) {
    return request(`/scheduling/lane/list`, 'get', params || {})
}
//查询送货地址
export function deliveryList(params) {
    return request(`/scheduling/deliveryLocation/list`, 'get', params || {})
}
//添加任务
export function addTask(params) {
    return request(`/scheduling/task/add`, 'post', params || {})
}
//当日任务列表
export function queryTaskTime(params) {
    return request(`/scheduling/task/listCurDay`, 'get', params || {})
}
//删除任务
export function delTask(params) {
    return request(`/scheduling/task/remove`, 'get', params || {})
}
//改派
export function reassignDrive(params) {
    return request(`/scheduling/task/reassign`, 'post', params || {})
}
//排队列表
export function getList(params) {
    return request(`/scheduling/driverVehicle/listDistributionDriver`, 'get', params || {})
}
//指派
export function Assign(params) {
    return request(`/scheduling/task/assign`, 'post', params || {})
}
//开始匹配
export function taskAutoAssignment(params) {
    return request(`/scheduling/task/taskAutoAssignment`, 'post', params || {})
}
//确认大部
export function publishTask(params) {
    return request(`/scheduling/task/publishTask`, 'post', params || {})
}
//异常查询
export function queryAbnormalReport(params) {
    return request(`/scheduling/dispatch/queryAbnormalReport`, 'get', params || {})
}
//异常详情
export function getAbnormalReport(params) {
    return request(`/scheduling/dispatch/getAbnormalReport`, 'get', params || {})
}
//异常处理
export function handleAbnormalReport(params) {
    return request(`/scheduling/dispatch/handleAbnormalReport`, 'get', params || {})
}
//审批列表
export function queryAskForLeave(params) {
    return request(`/scheduling/leave/queryAskForLeave`, 'get', params || {})
}
//审批操作
export function askForLeaveApproval(params) {
    return request(`/scheduling/leave/askForLeaveApproval`, 'post', params || {})
}
//删除审批
export function deleteApproval(params) {
    return request(`/scheduling/leave/delete`, 'get', params || {})
}
//装货视图查询
export function getLaneList(params) {
    return request(`/scheduling/lane/listDetail`, 'get', params || {})
}

//装货视图卡片拖拽
export function laneJump(params) {
    return request(`/scheduling/lane/jump`, 'post', params || {})
}
//上移
export function moveUp(params) {
    return request(`/scheduling/lane/moveUp`, 'post', params || {})
}
//下移
export function moveDown(params) {
    return request(`/scheduling/lane/moveDown`, 'post', params || {})
}
//置顶
export function sticky(params) {
    return request(`/scheduling/lane/sticky`, 'post', params || {})
}
//装货视图统计信息
export function statistic(params) {
    return request(`/scheduling/lane/statistic`, 'get', params || {})
}
//电子围栏查询
export function deliveryLocation(params) {
    return request(`/scheduling/deliveryLocation/listDetail`, 'get', params || {})
}
//添加电子围栏
export function addLocation(params) {
    return request(`/scheduling/deliveryLocation/add`, 'post', params || {})
}
//添加电子围栏
export function delLocation(params) {
    return request(`/scheduling/deliveryLocation/delete`, 'get', params || {})
}
//修改电子围栏
export function editLocation(params) {
    return request(`/scheduling/deliveryLocation/update`, 'post', params || {})
}
//任务详情
export function getTaskDetail(params) {
    return request(`/scheduling/task/dispatcherDetail`, 'get', params || {})
}
//修改日志列表查询
export function pageQueryDriverChangeLog(params) {
    return request(`/scheduling/driverVehicle/pageQueryDriverChangeLog`, 'get', params || {})
}
//修改日志详情
export function queryDriverChangeLogById(params) {
    return request(`/scheduling/driverVehicle/queryDriverChangeLogById`, 'get', params || {})
}
//根据送货地址，获取配送距离与配送时长
export function waypoint(params) {
    return request(`/scheduling/distance/waypoint`, 'post', params || {})
}

//任务超时消息列表接口（轮询）
export function queryOvertimeTask(params) {
    return request(`/scheduling/task/warn`, 'get', params || {})
}